// WS5 PR3.3b — localStorage helper per first-run coach dismiss flag.
//
// Versioning della chiave (v1) consente future re-prompt al cambio coach
// (es. C5 admin Studio Web wizard, futuri tier). Storage failure (private
// mode Safari, quota, ecc.) → coach mostrato comunque (fail-open: meglio
// re-mostrarlo che mai mostrarlo).

const STORAGE_KEY = 'oniri.ws5.coach.dismissed.v1';

export function isCoachDismissed(): boolean {
	try {
		return localStorage.getItem(STORAGE_KEY) === '1';
	} catch {
		// Storage non disponibile (Safari private mode, quota, SSR) → fail-open
		// e mostra il coach: meglio mostrare 1 volta in piu' che 0 volte.
		return false;
	}
}

export function markCoachDismissed(): void {
	try {
		localStorage.setItem(STORAGE_KEY, '1');
	} catch {
		// Storage non disponibile → no-op. Sessione corrente terra' lo stato
		// in memoria (hideCoach cambio state); al refresh il coach ricompare,
		// ma e' un edge case accettabile (private mode utenti).
	}
}

/** Esportato per test + future "Help → mostra coach di nuovo" (PR3.3c
 *  modality-toggle). */
export function resetCoachDismissed(): void {
	try {
		localStorage.removeItem(STORAGE_KEY);
	} catch {
		// no-op
	}
}
